import { useEffect, useState, type FocusEvent } from "react";
import { CTL_GroupLabel } from "./CTL_GroupLabel";

export interface PropTypeCTLInput{
  type?:string;
  readOnly?:boolean
  value?:string;
  autoComplete?:string;
  label?:string; 
  placeHolder?:string;
  errMessage?:string;
  className?:string;
  onChanging?:(val:string)=>void;
  onChange?:(val:string)=>void;
  onFocus?:(e:FocusEvent<HTMLInputElement>)=>void;
  onBlur?:(e:FocusEvent<HTMLInputElement>)=>void;
}

export function CTL_Input( { type="text", ...props}:PropTypeCTLInput ){
  const [value, setValue] = useState(props.value);
  
  useEffect( ()=>{
    const change = ()=>setValue( props.value );
    change();
  }, [props.value] );

  function _onChangeValue( v_:string){
    // console.log("!Changed")
    if(props.onChange) props.onChange( v_.toString() );
    setValue( v_.toString() );
  }
  
  function _onChangingValue( v_:string){
    if(props.onChanging) props.onChanging( v_.toString() );
    setValue( v_.toString() );
  }
  
  return (
    <>
      <CTL_GroupLabel label={props.label}>
        <input 
          readOnly={props.readOnly}
          type={type}
          autoComplete={props.autoComplete?props.autoComplete:''} 
          placeholder={props.placeHolder}
          className={`
            w-full
            ${props.readOnly?'':'border'}
            p-2 py-1.5 border-zinc-300 rounded-md outline-none placeholder:text-[.9rem]
            ${props.className}
          `}
          onFocus={props.onFocus?props.onFocus:()=>null}
          onBlur={(e)=>{
            _onChangeValue(e.target.value)
            if(props.onBlur)props.onBlur(e);
          }}
          onChange={ (e)=>{_onChangingValue(e.target.value)} }
          value={value}
          onClick={(e)=>e.stopPropagation()}
        />
        {props.errMessage&&props.errMessage!=''?<div className="text-red-400 text-[.8rem]">{props.errMessage}</div>:null}
        
      </CTL_GroupLabel>
    </>
  )
}
